import { color as foundationColor, effects as foundationEffects, size } from "../foundation";
import { color as semanticColor, spacing, effects } from "../semantic";

export const segmentedControl = {
    color: {
        tab: {
            bg: {
                inactive: semanticColor.bg.surface,
                active: foundationColor.primary[100],
            },
            content: {
                inactive: foundationColor.neutral[700],
                inactiveHover: foundationColor.primary[600],
                active: foundationColor.primary[600],
            }
        },
        track: {
            bg: semanticColor.bg.surface,
            border: semanticColor.border.default.light,
        }
    },
    size: {
        tab: {
            height: {
                sm: size[700],
                md: size[800],
                lg: size[1500],
                mobile: size[1000]
            }
        },
        icon: {
            sm: size[300],
            md: size[400],
            lg: size[500],
            mobile: size[600]
        }
    },
    effects: {
        radius: {
            default: effects.radius.md,
            lg: effects.radius.sm 
        }
    },
    spacing: {
        tab: {
            padding: {
                x: spacing.xxs,
            }
        },
        track: {
            padding: spacing.tiny,
        },
        icon: {
            padding: spacing.tiny
        }
    },
    state: {
        disabled: foundationEffects.opacity[70],   // higher opacity than default disabled state since some disabled controls need to be legible (ex: liter flow type from EMR)
    },
};

export default segmentedControl;